import React from "react"

export default function CarBar(props) {
  return (
    <div className="carContainer">
      <div className="carType">
        <div className="carMake">
          {props.year}{" "}
          <strong>
            {props.make} {props.model}
          </strong>
        </div>
      </div>
    </div>
  )
}
